<template><div><h1 id="hauptartikel" tabindex="-1"><a class="header-anchor" href="#hauptartikel"><span>Hauptartikel</span></a></h1>
<p>Hauptartikel — Verwaltet Hauptartikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Fenster werden Hauptartikel gepflegt. Mehrere einzelne Artikel können zu einem Hauptartikel zugeordnet werden, resp. ein Hauptartikel beinhaltet einzelne Artikelvarianten. Z.B. ein Artikel Hose bildet den Hauptartikel und die Artikelvarianten davon sind Hose in blau, Hose in Rot oder Hose in Weiss, etc.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Hauptartikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nummer:</dt>
<dd>Hauptartikelnummer, eindeutiger Identifikator eines Hauptartikels, 7-stellig alphanumerisch.</dd>
<dt>AnzVar:</dt>
<dd>Anzahl Varianten, zeigt die Anzahl der zugeordneten Varianten an.</dd>
<dt>Bezeichnungen</dt>
<dd>Artikelbezeichnung, max. 4-sprachig möglich in Deutsch, Französisch, Italienisch und Englisch</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


